<template>
  <section
    class="boost-main pt-16 pb-[51px] text-center min-[1024px]:pt-[102px]"
  >
    <div class="mx-auto min-w-[320px] max-w-container px-4">
      <h2 class="landing_h2 mb-5 text-center">
        <Translate translate-key="how_it_works_last_home.title" />
      </h2>
      <div
        class="mx-auto max-w-[1200px] text-left leading-[1.5] prose prose-gray prose-p:mb-[38px] prose-p:last:mb-0 prose-p:text-gray-700 prose-p:leading-[1.5] prose-a:text-success prose-a:underline hover:prose-a:no-underline"
        v-html="t('how_it_works_last_home.text')"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import Translate from "~/shared/components/i18n/Translate/Translate.vue";

const { t } = useI18n();
</script>
